@if (isAddUserButtonEnabled) {
  <button
    mat-button
    (click)="addUserToThisSession()"
    tabIndex="0"
    data-testid="header-add-user"
  >Add Participant</button>
}

